import { createIcon } from "@chakra-ui/react";

export const Pin = createIcon({
  displayName: "Fun",
  viewBox: "0 0 124 124",
  path: [
    <path
      d="m78.473 94.86-5.535 8.663-8.027 6.383-8.166 6.005-9.331 3.919-10.108 3.769-1.446-10.756-.86-10.168 1.187-10.165 2.755-9.876 4.57-9.183 13.193-15.61 8.573-5.587 9.242-4.319L84.758 45l2.363 10.473.123 10.28-1.12 10.192-3.287 9.689-4.364 9.227z"
      fill="#2B2C3D"
    />,
    <path
      d="m78.37 93.161-5.367 8.4-7.732 6.222-7.862 5.859-8.96 3.856-9.7 3.718-1.296-10.361-.74-9.799 1.22-9.813 2.718-9.547 4.447-8.894L57.85 57.638l8.249-5.459 8.878-4.24 9.82-2.916 2.173 10.08.033 9.915-1.155 9.838-3.225 9.371-4.251 8.934z"
      fill="#ADCF77"
    />,
    <path
      d="m46.527 94.86 5.535 8.663 8.027 6.383 8.166 6.005 9.332 3.919 10.107 3.769 1.446-10.756.86-10.168-1.186-10.165-2.756-9.876-4.57-9.183-13.193-15.61-8.573-5.587-9.242-4.319L40.242 45l-2.363 10.473-.123 10.28 1.12 10.192 3.287 9.689 4.364 9.227z"
      fill="#2B2C3D"
    />,
    <path
      d="m46.63 93.161 5.367 8.4 7.732 6.222 7.862 5.859 8.96 3.856 9.7 3.718 1.296-10.361.74-9.799-1.22-9.813-2.718-9.547-4.447-8.894L67.15 57.638l-8.249-5.459-8.878-4.24-9.82-2.916-2.173 10.08-.033 9.915 1.155 9.838 3.225 9.371 4.252 8.934z"
      fill="#ADCF77"
    />,
    <path
      d="m42 77.42.01 10.279 3.335 9.698 3.656 9.454 5.76 8.322 6.496 8.611 7.003-8.291 6.192-8.11 4.465-9.208 2.987-9.809 1.085-10.2-2.73-20.256-4.224-9.32-5.471-8.61L63.51 32l-7.623 7.56-5.631 8.602-4.537 9.195-2.438 9.936L42 77.42z"
      fill="#2B2C3D"
    />,
    <path
      d="m43 76.041.009 9.968 3.174 9.404 3.479 9.168 5.48 8.069 6.18 8.35 6.664-8.039 5.892-7.865 4.248-8.929 2.842-9.51L82 76.766l-2.597-19.643-4.02-9.037-5.205-8.35L63.466 32l-7.253 7.33-5.358 8.342-4.316 8.916-2.32 9.635L43 76.042z"
      fill="#55643C"
    />,
    <path
      d="M114 51.791c0 28.604-23.281 51.791-52 51.791s-52-23.187-52-51.79C10 23.187 33.281 0 62 0s52 23.188 52 51.791z"
      fill="#55643C"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62 102.282c28.006 0 50.7-22.61 50.7-50.49C112.7 23.91 90.006 1.3 62 1.3c-28.006 0-50.7 22.61-50.7 50.491 0 27.88 22.694 50.491 50.7 50.491zm0 1.3c28.719 0 52-23.187 52-51.79C114 23.187 90.719 0 62 0S10 23.188 10 51.791c0 28.604 23.281 51.791 52 51.791z"
      fill="#2B2C3D"
    />,
    <path
      d="M107.5 51.791c0 25.028-20.371 45.317-45.5 45.317S16.5 76.82 16.5 51.791 36.871 6.474 62 6.474s45.5 20.29 45.5 45.317z"
      fill="#ADCF77"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62 95.808c24.416 0 44.2-19.712 44.2-44.017 0-24.305-19.784-44.017-44.2-44.017-24.416 0-44.2 19.712-44.2 44.017 0 24.305 19.784 44.017 44.2 44.017zm0 1.3c25.129 0 45.5-20.289 45.5-45.317S87.129 6.474 62 6.474 16.5 26.764 16.5 51.79c0 25.028 20.371 45.317 45.5 45.317z"
      fill="#2B2C3D"
    />,
    <path
      d="m37.074 60.452.152 1.994c.14 1.836 1.089 3.285 2.292 3.5l1.306.232-1.306.232c-1.203.213-2.152 1.662-2.292 3.5l-.152 1.996-.152-1.996c-.14-1.838-1.088-3.287-2.291-3.5l-1.307-.232 1.307-.232c1.203-.215 2.151-1.664 2.291-3.5l.152-1.994z"
      fill="#fff"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.981 53.164a15.07 15.07 0 0 0-8.56-8.575c5.596-2.177 9.574-7.626 9.574-13.99v-1.016H47V58.58c0 8.271 6.72 15.001 14.981 15.001 8.26 0 14.981-6.73 14.981-15.001V43.574h-1.014c-6.354 0-11.793 3.985-13.967 9.59zm12.953-7.52v11.959c-5.097.344-9.502 3.25-11.94 7.443v-6.465c0-6.813 5.27-12.417 11.94-12.937zM60.967 58.581v6.444a15.089 15.089 0 0 0-2.36-3.065 14.855 14.855 0 0 0-9.579-4.358V45.645c6.67.52 11.94 6.124 11.94 12.937zM49.028 31.614h11.9c-.493 6.346-5.565 11.426-11.9 11.92v-11.92zm.043 28.025c6.3.512 11.34 5.56 11.853 11.87-6.302-.513-11.342-5.56-11.853-11.87zm13.967 11.87a12.89 12.89 0 0 1 3.75-8.112 12.844 12.844 0 0 1 8.104-3.758c-.512 6.31-5.553 11.357-11.854 11.87z"
      fill="#55643C"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M76.962 43.574V58.58c0 8.271-6.72 15.001-14.981 15.001-8.26 0-14.981-6.73-14.981-15.001V29.583h15.995v1.015c0 5.88-3.394 10.977-8.322 13.437-.407.203-.825.388-1.252.554a15.087 15.087 0 0 1 8.56 8.574c.166-.427.351-.846.554-1.254 2.456-4.936 7.544-8.335 13.413-8.335h1.014zm-14.981 7.242c2.73-4.91 7.963-8.242 13.967-8.242h2.014V58.58c0 8.822-7.167 16.001-15.981 16.001S46 67.403 46 58.581V28.583h17.995v2.015c0 6.014-3.328 11.257-8.231 13.991a16.096 16.096 0 0 1 6.217 6.227zm12.953-5.172c-.337.027-.67.066-1 .118-6.189.972-10.94 6.35-10.94 12.819v6.465c.304-.522.639-1.024 1-1.504 2.546-3.373 6.478-5.638 10.94-5.939V45.644zm-1 1.131c-5.633.962-9.94 5.89-9.94 11.806v3.383c2.508-2.832 6.001-4.77 9.94-5.268v-9.921zM59.967 61.947V58.58c0-5.916-4.306-10.844-9.939-11.806v9.92a15.85 15.85 0 0 1 9.287 4.559c.225.225.442.456.652.693zm1-3.366c0-6.469-4.75-11.847-10.939-12.82a12.94 12.94 0 0 0-1-.117v11.959c3.62.24 6.99 1.764 9.579 4.357a15.09 15.09 0 0 1 2.36 3.065v-6.444zm-1.17-25.967h-9.769v9.79c4.979-.85 8.922-4.8 9.77-9.79zm-10.769-1v11.92c.337-.026.67-.065 1-.117 5.533-.87 9.916-5.26 10.783-10.803.051-.33.09-.663.117-1h-11.9zm1.058 28.148a12.93 12.93 0 0 0-1.015-.123c.028.342.069.68.123 1.015.884 5.494 5.228 9.844 10.715 10.731.334.054.673.095 1.015.123a12.98 12.98 0 0 0-.123-1.015c-.887-5.494-5.23-9.844-10.715-10.73zm9.674 10.582c-4.813-.91-8.618-4.72-9.525-9.54 4.81.908 8.615 4.718 9.525 9.54zm3.4.15c-.054.335-.095.673-.122 1.014.342-.027.68-.069 1.014-.123 5.487-.887 9.832-5.237 10.717-10.732.054-.334.095-.672.123-1.014a12.847 12.847 0 0 0-8.103 3.758 12.888 12.888 0 0 0-3.63 7.096zm1.04-.15c4.814-.909 8.621-4.72 9.528-9.543a11.851 11.851 0 0 0-6.231 3.302 11.891 11.891 0 0 0-3.297 6.241z"
      fill="#2B2C3D"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M66.172 29.582v2.032h8.763v8.778h2.028v-10.81H66.172z"
      fill="#55643C"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.172 28.582h12.79v12.81h-4.027v-8.778h-8.763v-4.032zm1 3.032v-2.032h10.79v10.81h-2.027v-8.778h-8.763z"
      fill="#2B2C3D"
    />,
  ],
});

export default Pin;
